module.exports = __webpack_public_path__ + "media/images/flags/64/Burkina-Faso-d12e6fb3d38bd5d123f372336944eb97.png";